import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { getUsers, updateVisit } from "../network/api";
import { ROLES } from "../constants/roles";
import { notify, serverError } from "../utils/notify";

// D4 — inline technician (re)assignment for a visit, mirroring the ticket assign control.
export default function VisitReassign({ visit, onChange }) {
  const [techs, setTechs] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getUsers({ role: ROLES.TECHNICIAN })
      .then((r) => setTechs(r.users || []))
      .catch(() => setTechs([]));
  }, []);

  const assign = async (val) => {
    setSaving(true);
    try {
      await updateVisit(visit._id, { technician: val || null });
      notify.success(val ? "Technician assigned" : "Visit unassigned");
      onChange?.();
    } catch (e) {
      notify.error(serverError(e, "Failed to reassign"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Select
      size="small"
      allowClear
      showSearch
      optionFilterProp="label"
      style={{ minWidth: 180 }}
      placeholder="Unassigned"
      loading={saving}
      value={visit.technician?._id}
      onChange={assign}
      options={techs.map((t) => ({ value: t._id, label: t.name }))}
    />
  );
}
